import { render } from "./PhoneNumberInput.vue?vue&type=template&id=148ae226&ts=true"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=ts"

import "./PhoneNumberInput.vue?vue&type=style&index=0&id=148ae226&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__